import type { Ref } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";

import { AddressBook, type AddressBookHandle } from "./AddressBook";
import {
  type AddressBookDataProps,
  addressBookDataSchema,
} from "./AddressBook.schema";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    "address-book": {
      props: AddressBookDataProps;
      handle: AddressBookHandle;
    };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-address-book": HTMLElement & AddressBookHandle;
  }
}

export function RWCAddressBook({
  ref,
}: AddressBookDataProps & { ref?: Ref<AddressBookHandle> }) {
  return <AddressBook ref={ref} />;
}

componentManager.register(
  rwc("address-book", {
    component: RWCAddressBook,
    dataSchema: addressBookDataSchema,
  }),
);
